<template>
  <div class="condition-node-config">
    <el-form label-width="100px" >
      <!-- <el-form-item label="优先级：" prop="level">
        
      </el-form-item> -->
      <!-- <el-form-item label="条件组关系：">
        <el-switch v-model="config.groupsType" active-color="#00B498"
                   inactive-color="#c1c1c1" active-value="AND" inactive-value="OR"
                   active-text="且" inactive-text="或">
        </el-switch>
      </el-form-item> -->
      <!-- <el-form-item label="条件组表达式：" class="condition-group-expression">
        <el-input size="mini" v-model="config.expression" placeholder="输入条件组关系表达式  &为与，|为或"/>
        <span class="item-desc">使用表达式构建复杂逻辑，例如: (A & B) | C</span>
      </el-form-item> -->
      <!-- <div class="row">
        <div class="row-label">条件名称</div>
        {{config}}
        <el-input size="mini" v-model="config.name" placeholder="请输入"/>
      </div> -->
      <div class="row">
        <div class="row-label">条件名称</div>
        <el-input size="small" v-model="selectedNode.name" placeholder="请输入" maxlength="24" show-word-limit/>
      </div>
      <div class="row">
        <div class="row-label">优先级</div>
        <el-popover placement="right"  width="250" trigger="click" popper-class="popover-leave">
          <div class="popover-leave-title">拖拽条件调整优先级顺序</div>
          <draggable style="width: 100%; min-height:25px" :list="prioritySortList.slice(0, -1)" group="from" :options="sortOption">
            <div :class="{'drag-no-choose': true, 'drag-hover': cd.id === selectedNode.id}"
                 v-for="(cd, index) in prioritySortList.slice(0, -1)">
              <ellipsis class="name" style="width: 160px;" hover-tip :content="cd.name"/>
              <div class="level">优先级 {{ index + 1 }}</div>
            </div>
          </draggable>
          <draggable style="width: 100%; min-height:25px" :list="prioritySortList.slice(-1)" group="from" :options="sortOption" :disabled="true">
            <div :class="{'drag-no-choose': true, 'drag-hover': cd.id === selectedNode.id,'no-drag':true}"
                 v-for="(cd, index) in prioritySortList.slice(-1)">
              <ellipsis class="name" style="width: 160px;" :content="cd.name"/>
              <div class="level">优先级 {{ prioritySortList.length }}</div>
            </div>
          </draggable>
          <el-button icon="el-icon-sort" class="btn-leave" size="small" slot="reference">优先级{{ nowNodeLeave + 1 }}</el-button>
        </el-popover>
      </div>
    </el-form>
    <!-- <div>
      <el-button type="primary" size="mini" icon="el-icon-plus" style="margin: 0 15px 15px 0" plain @click="addConditionGroup">
        添加条件组
      </el-button>
      <span class="item-desc">只有必填选项才能作为审批条件</span>
    </div> -->
    <group-item/>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import GroupItem from "./ConditionGroupItemConfig.vue"

export default {
  name: "ConditionNodeConfig",
  components: {draggable, GroupItem},
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    selectedNode() {
      return this.$store.state.selectedNode
    },
    select() {
      return this.config.assignedUser || []
    },
    nowNodeLeave() {
      return this.prioritySortList.indexOf(this.selectedNode)
    },
    //条件节点
    prioritySortList() {
      let node = this.$store.state.nodeMap.get(this.selectedNode.parentId)
      console.log(this.selectedNode.id, node)
      if (node) {
        return node.branchs || []
      }
      return []
    }
  },
  data() {
    return {
      sortOption: {
        animation: 300,
        chosenClass: 'choose',
        scroll: true,
        sort: true
      }
    }
  },
  methods: {
    addConditionGroup() {
      this.config.groups.push({
        cids:[],
        groupType: "OR",
        conditions:[]
      })
    },
    selectUser() {
      this.showOrgSelect = true
    },
    selected(select) {
      console.log(select)
      this.showOrgSelect = false
      select.forEach(val => this.select.push(val))
    },
    removeOrgItem(index) {
      this.select.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.condition-node-config /deep/ {
  .el-form-item{
    margin-bottom: 2px;
  }
  .el-form-item__label{
    font-size: 12px;
    font-weight: bold;
    color: #2F3030;
  }
  .item-desc{
    font-size: 12px;
    color: #616363;
  }
}
.condition-group-expression /deep/ .el-form-item__content{
  .item-desc{
    position: relative;
    top: -15px;
  }
}
.choose {
  border-radius: 5px;
  margin-top: 2px;
  background: #f4f4f4;
  border: 1px dashed #00B498 !important;
}

.drag-hover {
  color: #00B498
}

.drag-no-choose {
  cursor: move;
  background: #f8f8f8;
  border-radius: 5px;
  margin: 5px 0;
  height: 25px;
  line-height: 25px;
  padding: 5px 10px;
  border: 1px solid #ffffff; 
  display: inline-flex;
  align-items: center;
  // div{
  //   display: inline-block;
  //   font-size: small !important;
  // }

  // div:nth-child(2) {
  //   float: right !important;
  // }
  .name{
    float: left;
  }
  .level {
    color: #616363;
    font-size: 12px;
    line-height: 1;
    border: 1px solid #E3E6E5;
    padding: 3px 4px 4px;
    border-radius: 2px;
    float: right;
    background-color: #ffffff;
  }
}
.row{
  /* margin-bottom: 10px; */
  .row-label{
    font-size: 14px;
    display: block;
    color: #2F3030;
    height: 28px;
  }
  .btn-leave{
    width: 100px;
    text-align: left;
  }
  
}
.row +.row{
  margin-top: 12px;
}
.popover-leave{
  .popover-leave-title{
    font-size: 14px;
    margin-bottom: 4px;
  }
}
.no-drag {
  cursor: not-allowed;
  background: #f8f8f8;
}
</style>
